export const inspectionsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.saskroofingcompany.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: "https://www.saskroofingcompany.com/services",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Roof Inspections",
        item: "https://www.saskroofingcompany.com/services/inspections",
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": "https://www.saskroofingcompany.com/services/inspections#service",
    serviceType: "Roof Inspection",
    name: "Roof Inspection",
    description:
      "Professional roof inspections in Saskatchewan. We assess your roof's condition, identify hidden damage, and provide honest recommendations.",
    url: "https://www.saskroofingcompany.com/services/inspections",
    provider: {
      "@id": "https://www.saskroofingcompany.com/#localbusiness",
      "@type": "RoofingContractor",
      name: "Sask Roofing Company",
      url: "https://www.saskroofingcompany.com/",
      telephone: "+1-639-739-7969",
    },
    areaServed: [
      {
        "@type": "City",
        name: "Saskatoon",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Regina",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Moose Jaw",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Prince Albert",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Swift Current",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Yorkton",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Estevan",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Weyburn",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
    ],
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "CAD",
      lowPrice: "0",
      highPrice: "0",
    },
    availableChannel: {
      "@type": "ServiceChannel",
      serviceUrl: "https://www.saskroofingcompany.com/contact",
      servicePhone: {
        "@type": "ContactPoint",
        telephone: "+1-639-739-7969",
        contactType: "customer service",
        areaServed: "CA-SK",
        availableLanguage: "English",
      },
    },
    termsOfService: "https://www.saskroofingcompany.com/about#warranty",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "87",
      bestRating: "5",
      worstRating: "1",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How often should I have my roof inspected?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We recommend a professional inspection every 3-5 years for roofs over 10 years old, or immediately following a severe wind or hail storm.",
        },
      },
      {
        "@type": "Question",
        name: "Are your roof inspections really free?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, our standard residential roof inspections and replacement estimates are completely free and carry no obligation.",
        },
      },
      {
        "@type": "Question",
        name: "Do I need to be home for the inspection?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It's preferred so we can discuss our findings with you, but not strictly necessary for an exterior inspection. We can always email you the photos and report and discuss it over the phone.",
        },
      },
    ],
  },
];
